import { ParkDeck } from "../components/parkdeck.component";

export function ParksPage(props: any) {
  return <ParkDeck title="All Hikes by Park" />;
}
